import React from "react";
import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import Grid from "@material-ui/core/Grid";
import Labelbox from "../../helpers/labelbox/labelbox";
import Button from "@material-ui/core/Button";
import AddAPhotoIcon from '../../Images/doc.svg';
import KeyboardVoiceIcon from '../../Images/voi.svg';
import { Recorder } from 'react-voice-recorder'
import 'react-voice-recorder/dist/index.css'
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { notification } from "antd";
import More from "../../Images/more.svg";
import PropTypes from "prop-types";

class TicketModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      menulist: [],
      menu: "",
      menu_error: false,
      remark: "",
      remark_error: false,
      openRecordModal: false,
      audioDetails: {
        url: null,
        blob: null,
        chunks: null,
        duration: {
          h: 0,
          m: 0,
          s: 0
        }
      },
      audio_record_file: [],
      audio_record: [],
      playRecord: false,
      audio_url: "",
      img_url: "",
      imagedata: [],
      playContent: "",
      setVar_Progress: 0,
      setVar_Progressing: 0,
      fileupload_error: false,
      isDisable:false
    };
  }
  componentDidMount() {
    let arr = document.getElementsByClassName("appbar_sideicons")[0].getElementsByTagName("a");
    let menulist = [];
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].getElementsByClassName("MuiListItemText-root")[0].getElementsByTagName("span")[0].innerHTML.toLocaleLowerCase() != "ticketing") {
        if (arr[i].getElementsByClassName("MuiListItemText-root")[0].getElementsByTagName("span")[0].innerHTML == 'Revenue &amp; Settlement') {
          menulist.push({
            "name": 'Revenue & Settlement',
            "value": 'Revenue & Settlement'
          })
        } else {
          menulist.push({
            "name": arr[i].getElementsByClassName("MuiListItemText-root")[0].getElementsByTagName("span")[0].innerHTML,
            "value": arr[i].getElementsByClassName("MuiListItemText-root")[0].getElementsByTagName("span")[0].innerHTML
          })
        }
      }
    }
    this.setState({ menulist })
  }
  ticketSubmit() {
    let is_valid = true;
    if (this.state.menu == "") {
      this.setState({ menu_error: true })
      is_valid = false;
    }
    // if (this.state.remark == "") {
    //   this.setState({ remark_error: true })
    //   is_valid = false;
    // }
    if (this.state.imagedata == '' && this.state.audio_url == ''& this.state.remark == "") {
      this.setState({ fileupload_error: true });
      this.setState({ remark_error: true })
      is_valid = false;
    }

    if (is_valid) {
      this.ticketSave();
    }
  }
  ticketSave() {
    this.setState({ isDisable : true });
    let formdata = new FormData();
    formdata.append('image_files', this.state.imagedata.length != 0 ?  this.state.imagedata?.split("?")[0] : '' );
    formdata.append('audio_files', this.state.audio_url != '' ? this.state.audio_url?.split("?")[0] : '');
    formdata.set("screen_name", this.state.menu);
    formdata.set("remarks", this.state.remark);
    formdata.set("module_name", "Pharmacy");
    formdata.set("vendor_id", localStorage.getItem("pharmacy_id") ? localStorage.getItem("pharmacy_id") : "11");
    axiosInstance({
      method: "post",
      url: apiurl + "admin/save_vendor_ticket",
      data: formdata,
    }).then((response) => {
      if (response.data.status == 1) {
        this.setState({ openRecordModal: false }, () => {
          this.setState({isDisable:false});
          console.log(response.data.data.ticket_no)
          this.props.ticketSuccess(response.data.data.ticket_no)
        });
      }
      else {
        notification.error({
          message: "Ticket added failed",
        });
      }
    }).catch((error) => {
      console.log(error,"error");
    });
  }
  handleAudioStop(data) {
    console.log(data)
    this.setState({ audioDetails: data });
  }
  handleAudioUpload(file) {
    if (file) {
      this.setState({ isDisable : true });
      file["name"] = "TOM-Suport-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + ".mp3";
      file["webkitRelativePath"] = "";
      file["lastModifiedDate"] = new Date();
      let filename = "TOM-Suport-" + new Date().getDate() + "-" + new Date().getMonth() + "-" + new Date().getFullYear() + "-" + new Date().getHours() + "-" + new Date().getMinutes() + "-" + new Date().getSeconds() + ".mp3";
      let audioFile = new File([file], filename);
      const formData = new FormData();
      formData.append('file', audioFile);
      formData.append('module_id', "9");
      formData.append('pathLocation', "SUPPORT/");
      axiosInstance({
        method: "POST",
        url: apiurl + "admin/awsS3FileUpload",
        data: formData,
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.setState({ setVar_Progress: percentage })
        },
      }).then((response) => {
        this.setState(
          {
            audio_url: response.data.filepath.Location,
          isDisable:false
          }
        );
      });
    }
    this.setState({ openRecordModal: false });
  }
  handleCountDown(data) {
    console.log(data);
  }
  handleReset() {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0
      }
    };
    this.setState({ audioDetails: reset });
  }
  handleOpenAudioRecord = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: 0,
        m: 0,
        s: 0
      }
    };
    this.setState({ openRecordModal: true, audioDetails: reset, fileupload_error: false })
    this.setState({ remark_error: false })
  }
  handleClickclose = () => {
    this.setState({ openRecordModal: false }, () => { this.handleReset() });
  };
  handleClickPlayOpen = (data, type) => {
    if (type == "audio") {
      this.setState({ playRecord: true, audio_url: data, playContent: type });
    }
    else {
      this.setState({ img_url: data, playRecord: true, playContent: type });
    }
  }
  handleClickPlayclose = () => {
    this.setState({ playRecord: false });
  }
  fileSelectedHandler = (e) => {
    this.setState({ remark_error: false,
     isDisable:true});
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    formData.append('module_id', "9");
    formData.append('pathLocation', "SUPPORT/");
    axiosInstance({
      method: "POST",
      url: apiurl + "admin/awsS3FileUpload",
      data: formData,
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log("percentage", percentage);
        this.setState({ setVar_Progressing: percentage })
      },
    }).then((response) => {
      if (response.data.filepath.Location != null) {
        this.setState({ imagedata: response.data.filepath.Location });
        this.setState({ fileupload_error: false,
          isDisable:false})
      }
    });
  }

  extractFilenameFromURL(url) {
    let parts = url.split('/');
    let filenameWithEncodedCharacters = parts[parts.length - 1];
    let filename = decodeURIComponent(filenameWithEncodedCharacters);
    return filename
  }
  render() {
    const { t } = this.props
    return (
      <div className={` ${this.props.i18n.language == "ar" ? "arabic_cls" : ""
        } ticket_add_div`}
        style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
        <Grid container spacing={2} style={{ padding: '0px 10px' }}>
          <Grid item md={12} sm={12}>
            <Labelbox
              className="label-box"
              labelname={t('tbl_head_screen_name')}
              type="select"
              valuelabel={"name"}
              valuebind={"value"}
              changeData={(data) =>
                this.setState({ menu: data, menu_error: false })
              }
              value={this.state.menu}
              error={this.state.menu_error}
              errmsg={t('please_select_menu')}
              dropdown={this.state.menulist}
            ></Labelbox>
          </Grid>
          <Grid item md={12} sm={12}>
            <Labelbox
              className="label-box"
              labelname={t('tbl_head_issue_raised_by_vendor')}
              type="textarea"
              changeData={(data) => this.setState({ remark: data, remark_error: false,fileupload_error: false })}
              value={this.state.remark}
              error={this.state.remark_error}
              errmsg={t('please_enter_remark')}
            />
          </Grid>
          <Grid item md={12} sm={12}>
            <Grid container>
              <Grid md={5} sm={5}>
                <div style={{ textAlign: 'center' }}>
                  <img src={KeyboardVoiceIcon} style={{ height: '50px', cursor: 'pointer' }} onClick={() => { this.handleOpenAudioRecord(); }} alt="keyboardvoiceicon" />
                  <div style={{
                    fontSize: '16px', color: 'black',
                    marginTop: (this.props.i18n.language == 'ar' ? '10px' : '')
                  }}> {t('click_to_record_audio')}
                  </div>
                </div>
                {this.state.setVar_Progress > 0 &&
                  <div className="progress_containers">
                    <progress max="100" value={this.state.setVar_Progress}></progress>
                    <span>{`${this.state.setVar_Progress}%`}</span>
                  </div>
                }

                {this.state.audio_url != "" && (
                  <div
                    style={{
                      display: "flex",
                      fontSize: "14px",
                      margin: "10px 0px",
                      color: "#707070",
                    }}
                  >
                    <div style={{ width: "90%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {this.extractFilenameFromURL(this.state.audio_url)}
                    </div>
                    <div style={{ width: "20%", textAlign: "center" }}>
                      <PlayArrowIcon
                        style={{
                          fill: "#510f30",
                          fontSize: "2rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.handleClickPlayOpen(
                            this.state.audio_url,
                            "audio"
                          );
                        }}
                      ></PlayArrowIcon>
                    </div>
                  </div>)}
                <div>
                  {this.state.audio_record.map((obj, i) => (
                    <div style={{ display: 'flex', fontSize: '14px', margin: '10px 0px', color: '#707070' }}>
                      <div style={{ width: '90%' }}>
                        {"Aud_Rec_" + ("00" + (i + 1)).slice(-3)}
                      </div>
                      <div style={{ width: '20%', textAlign: 'center' }}>
                        <PlayArrowIcon style={{ fill: '#83af40', fontSize: '2rem', cursor: 'pointer' }} onClick={() => { this.handleClickPlayOpen(obj, 'audio') }}></PlayArrowIcon>
                      </div>
                    </div>
                  ))}
                </div>
              </Grid>
              <Grid md={2} sm={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', color: 'black' }}> {t('or')} </Grid>
              <Grid md={5} sm={5}>
                <div style={{ textAlign: 'center' }}>
                  <img src={AddAPhotoIcon} style={{ height: '50px', cursor: 'pointer' }} onClick={() =>
                    document.getElementById("getFile").click()
                  } alt="addphotoicon" />
                  <input accept="image/*" type="file" style={{ display: 'none' }} id="getFile" multiple onChange={(e) => { this.fileSelectedHandler(e) }} />
                  <div style={{
                    fontSize: '16px', color: 'black',
                    marginTop: (this.props.i18n.language == 'ar' ? '10px' : '')
                  }}> {t('click_to_upload_screenshot')}
                  </div>

                  {this.state.setVar_Progressing > 0 &&
                    <div className="progress_containers">
                      <progress max="100" value={this.state.setVar_Progressing}></progress>
                      <span>{`${this.state.setVar_Progressing}%`}</span>
                    </div>
                  }
                </div>
                {this.state.imagedata != "" &&
                  <div style={{ display: 'flex', fontSize: '14px', margin: '10px 0px', color: '#707070' }}>
                    <div style={{ width: "90%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{this.extractFilenameFromURL(this.state.imagedata)}</div>
                    <div style={{ width: '20%', textAlign: 'center' }}>
                    <a href={this.state.imagedata} target="_blank">
                      <img style={{ fontSize: '2rem', cursor: 'pointer', height: '20px' }} src={More} 
                      // onClick={() => { this.handleClickPlayOpen(this.state.imagedata, 'image') }}
                       alt="moreicon"></img>
                      </a>
                    </div>
                  </div>
                }
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12} sm={12} style={{ textAlign: "center" }}>
            {this.state.fileupload_error == true && (
              <p className="Errormsg">{t('please_select_audio')}</p>
            )}
          </Grid>

          <Grid item md={12} sm={12} style={{ textAlign: 'center' }}>
            <Button className="ticketSubmit" disabled={this.state.isDisable} onClick={() => { this.ticketSubmit() }}> {t('submit')} </Button>
          </Grid>
        </Grid>
        <Modalcomp
          visible={this.state.openRecordModal}
          xswidth="xs"
          title={t("view_record")}
          clrchange="text_clr_change"
          closemodal={(e) => this.handleClickclose(e)}
          t={t}
          i18n={this.props.i18n}
        >
          <Recorder
            record={true}
            hideHeader={true}
            audioURL={this.state.audioDetails.url}
            showUIAudio
            handleAudioStop={data => this.handleAudioStop(data)}
            handleAudioUpload={data => this.handleAudioUpload(data)}
            handleCountDown={data => this.handleCountDown(data)}
            handleReset={() => this.handleReset()}
            mimeTypeToUseWhenRecording={`audio/webm`} 
          />
        </Modalcomp>
    
        <Modalcomp
          visible={this.state.playRecord}
          xswidth="xs"
          title={this.state.playContent == "audio" ? t("play_recoding") : t("view_image")}
          clrchange="text_clr_change"
          closemodal={(e) => this.handleClickPlayclose(e)}
          t={t}
          i18n={this.props.i18n}
        >
          <div>
            <div style={{ textAlign: 'center' }}>
              {this.state.playContent == "audio" ? <audio controls src={this.state.audio_url}></audio> : <img src={this.state.img_url} id="preimg" style={{ width: 'auto', height: '300px' }}  alt="preimgicon"/>}
            </div>            
          </div>
        </Modalcomp>
      </div>)
  }
}

TicketModal.propTypes = {
  i18n: PropTypes.shape({
    t: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
  size: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default TicketModal;
